import useAxios from 'axios-hooks';

export enum ESG_PLAN {
  DATA_PLATFORM = 'DATA_PLATFORM',
  GREEN_HOUSE = 'GREEN_HOUSE',
}
export type EsgPlanOptionType = 'esgPlatform' | 'esgGreenhouse';

export const esgPlanOptions: {
  value: EsgPlanOptionType;
  label: string;
}[] = [
  {
    value: 'esgPlatform',
    label: 'เปิดเผยข้อมูลจาก ESG Data Platform',
  },
  {
    value: 'esgGreenhouse',
    label: 'เปิดเผยข้อมูลเกี่ยวข้องกับการปล่อยก๊าซเรือนกระจก',
  },
];
export interface IEsgPlans {
  characteristicTypes: Array<ESG_PLAN>;
}

export const useSaveEsgPlans = (reportId?: string, payload?: IEsgPlans) => {
  return useAxios<IEsgPlans>(
    {
      method: 'POST',
      url: `esg-plans/esg/${reportId}`,
      data: payload,
    },
    { manual: true }
  );
};

export const useGetEsgPlans = (reportId?: string) => {
  return useAxios<IEsgPlans>({
    url: `/esg-plans/esg/${reportId}`,
  });
};
